
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/articles",
      function () {
        return require("private-next-pages/learn/articles/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/articles"])
      });
    }
  